module.exports = "- Announce sub-operations.\n"